import React from "react";
import Router from "./shared/Router";

import "./vendor/styles/bootstrap.scss";
import "./vendor/styles/appwork.scss";
import "./vendor/styles/theme-corporate.scss";
import "./vendor/styles/colors.scss";
import "./vendor/styles/uikit.scss";
import "./App.scss";

const App = () => {
  return <Router />;
};

export default App;
